import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Docker",
  "description": "monorepo에서 Docker를 사용하는 방법을 알아보세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Docker 이미지를 빌드하는 것은 모든 종류의 애플리케이션을 배포하는 일반적인 방법입니다. 그러나 monorepo에서 이를 수행하는 것에는 몇 가지 과제가 있습니다."
  }, {
    "heading": "문제점",
    "content": "monorepo에서는 관련 없는 변경 사항이 앱을 배포할 때 Docker가 불필요한 작업을 수행하게 만들 수 있습니다."
  }, {
    "heading": "문제점",
    "content": "다음과 같은 monorepo가 있다고 가정해 봅시다:"
  }, {
    "heading": "문제점",
    "content": "Docker를 사용하여 apps/api를 배포하려고 하므로 Dockerfile을 만듭니다:"
  }, {
    "heading": "문제점",
    "content": "이렇게 하면 루트 package.json과 루트 lockfile이 Docker 이미지로 복사됩니다. 그런 다음 종속성을 설치하고, 앱 소스를 복사하고, 앱을 시작합니다."
  }, {
    "heading": "문제점",
    "content": "또한 node_modules가 앱의 소스와 함께 복사되는 것을 방지하기 위해 .dockerignore 파일을 만들어야 합니다."
  }, {
    "heading": "lockfile이-너무-자주-변경됩니다",
    "content": "Docker는 앱을 배포하는 방법에 대해 매우 똑똑합니다. Turborepo와 마찬가지로 가능한 한 적은 작업을 수행하려고 합니다."
  }, {
    "heading": "lockfile이-너무-자주-변경됩니다",
    "content": "우리 Dockerfile의 경우, 이미지에 있는 파일이 이전 실행과 다른 경우에만 npm install을 실행합니다. 그렇지 않으면 이전에 있던 node_modules 디렉터리를 복원합니다."
  }, {
    "heading": "lockfile이-너무-자주-변경됩니다",
    "content": "즉, package.json, apps/api/package.json 또는 package-lock.json이 변경될 때마다 Docker 이미지가 npm install을 실행합니다."
  }, {
    "heading": "lockfile이-너무-자주-변경됩니다",
    "content": "이것은 훌륭하게 들리지만, 우리는 무언가를 깨닫습니다. package-lock.json은 monorepo에 대해 전역입니다. 즉, apps/web 내부에 새 패키지를 설치하면 apps/api가 재배포됩니다."
  }, {
    "heading": "lockfile이-너무-자주-변경됩니다",
    "content": "대규모 monorepo에서는 monorepo의 lockfile에 대한 변경 사항이 수십 또는 수백 개의 배포로 이어지기 때문에 엄청난 시간 손실이 발생할 수 있습니다."
  }, {
    "heading": "해결-방법",
    "content": "해결 방법은 Dockerfile에 대한 입력을 엄격하게 필요한 것으로만 제한하는 것입니다. Turborepo는 간단한 해결책인 turbo prune을 제공합니다."
  }, {
    "heading": "해결-방법",
    "content": "이 명령을 실행하면 ./out 디렉터리 내에 monorepo의 축소된 버전이 생성됩니다. api가 의존하는 워크스페이스만 포함합니다. 또한 lockfile을 축소하여 관련 node_modules만 다운로드됩니다."
  }, {
    "heading": "--docker-플래그",
    "content": "기본적으로 turbo prune은 모든 관련 파일을 ./out 내부에 넣습니다. 그러나 Docker로 캐싱을 최적화하려면 파일을 두 단계로 복사하는 것이 이상적입니다."
  }, {
    "heading": "--docker-플래그",
    "content": "먼저, 패키지를 설치하는 데 필요한 것만 복사하려고 합니다. --docker를 실행하면 ./out/json 내부에서 찾을 수 있습니다."
  }, {
    "heading": "--docker-플래그",
    "content": "그런 다음 ./out/full의 파일을 복사하여 소스 파일을 추가할 수 있습니다."
  }, {
    "heading": "--docker-플래그",
    "content": "이렇게 종속성과 소스 파일을 분리하면 종속성이 변경될 때만 npm install을 실행할 수 있으므로 훨씬 더 큰 속도 향상을 얻을 수 있습니다."
  }, {
    "heading": "--docker-플래그",
    "content": "--docker 없이는 모든 축소된 파일이 ./out 내부에 배치됩니다."
  }, {
    "heading": "예제",
    "content": "상세한 with-docker 예제는 prune을 최대한 활용하는 방법에 대해 자세히 설명합니다. 편의를 위해 Dockerfile을 복사했습니다."
  }, {
    "heading": "예제",
    "content": "monorepo의 루트에서 Dockerfile을 빌드합니다:"
  }, {
    "heading": "예제",
    "content": "이 Dockerfile은 standalone output\nmode를\n사용하는 Next.js 앱용으로 작성되었습니다."
  }, {
    "heading": "remote-caching",
    "content": "Docker 빌드 중에 원격 캐시를 활용하려면 빌드 컨테이너가 Remote Cache에 액세스할 수 있는 자격 증명을 가지고 있어야 합니다."
  }, {
    "heading": "remote-caching",
    "content": "Docker 이미지에서 시크릿을 처리하는 방법은 여러 가지가 있습니다. 여기서는 최종 이미지에 대해 숨겨질 빌드 인수로 시크릿을 사용하는 다단계 빌드를 사용하는 간단한 전략을 사용합니다."
  }, {
    "heading": "remote-caching",
    "content": "위와 유사한 Dockerfile을 사용한다고 가정하고, turbo build 바로 전에 빌드 인수에서 일부 환경 변수를 가져옵니다:"
  }, {
    "heading": "remote-caching",
    "content": "turbo는 이제 Remote Cache에 도달할 수 있습니다. 캐시되지 않은 Docker 빌드 이미지에 대한 Turborepo 캐시 적중을 보려면 프로젝트 루트에서 다음과 같은 명령을 실행하세요:"
  }],
  "headings": [{
    "id": "문제점",
    "content": "문제점"
  }, {
    "id": "lockfile이-너무-자주-변경됩니다",
    "content": "lockfile이 너무 자주 변경됩니다"
  }, {
    "id": "해결-방법",
    "content": "해결 방법"
  }, {
    "id": "--docker-플래그",
    "content": "--docker 플래그"
  }, {
    "id": "예제",
    "content": "예제"
  }, {
    "id": "remote-caching",
    "content": "Remote Caching"
  }]
};
import {Callout} from '#components/callout';
import {File, Folder, Files} from '#components/files';
import {CreateTurboCallout} from './create-turbo-callout.tsx';
export const toc = [{
  depth: 2,
  url: "#문제점",
  title: _jsx(_Fragment, {
    children: "문제점"
  })
}, {
  depth: 3,
  url: "#lockfile이-너무-자주-변경됩니다",
  title: _jsx(_Fragment, {
    children: "lockfile이 너무 자주 변경됩니다"
  })
}, {
  depth: 2,
  url: "#해결-방법",
  title: _jsx(_Fragment, {
    children: "해결 방법"
  })
}, {
  depth: 3,
  url: "#--docker-플래그",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--docker"
    }), " 플래그"]
  })
}, {
  depth: 3,
  url: "#예제",
  title: _jsx(_Fragment, {
    children: "예제"
  })
}, {
  depth: 2,
  url: "#remote-caching",
  title: _jsx(_Fragment, {
    children: "Remote Caching"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.docker.com/",
        children: "Docker"
      }), " 이미지를 빌드하는 것은 모든 종류의 애플리케이션을 배포하는 일반적인 방법입니다. 그러나 monorepo에서 이를 수행하는 것에는 몇 가지 과제가 있습니다."]
    }), "\n", _jsx(CreateTurboCallout, {}), "\n", _jsx(_components.h2, {
      id: "문제점",
      children: "문제점"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "monorepo에서는 관련 없는 변경 사항이 앱을 배포할 때 Docker가 불필요한 작업을 수행하게 만들 수 있습니다."
      })
    }), "\n", _jsx(_components.p, {
      children: "다음과 같은 monorepo가 있다고 가정해 봅시다:"
    }), "\n", _jsxs(Files, {
      children: [_jsxs(Folder, {
        name: "apps",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "api",
          defaultOpen: true,
          children: [_jsx(File, {
            name: "server.js"
          }), _jsx(File, {
            name: "package.json"
          })]
        }), _jsx(Folder, {
          name: "web",
          defaultOpen: true,
          children: _jsx(File, {
            name: "package.json"
          })
        })]
      }), _jsx(File, {
        name: "package.json"
      }), _jsx(File, {
        name: "package-lock.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Docker를 사용하여 ", _jsx(_components.code, {
        children: "apps/api"
      }), "를 배포하려고 하므로 Dockerfile을 만듭니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/api/Dockerfile",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " node:16"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /usr/src/app"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Copy root package.json and lockfile"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " package.json ./"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " package-lock.json ./"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Copy the api package.json"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apps/api/package.json ./apps/api/package.json"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " npm install"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Copy app source"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " . ."
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "EXPOSE"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " 8080"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "CMD"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [ "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"node\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ", "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"apps/api/server.js\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ]"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이렇게 하면 루트 ", _jsx(_components.code, {
        children: "package.json"
      }), "과 루트 lockfile이 Docker 이미지로 복사됩니다. 그런 다음 종속성을 설치하고, 앱 소스를 복사하고, 앱을 시작합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["또한 node_modules가 앱의 소스와 함께 복사되는 것을 방지하기 위해 ", _jsx(_components.code, {
        children: ".dockerignore"
      }), " 파일을 만들어야 합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: ".dockerignore",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "node_modules"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "npm-debug.log"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "lockfile이-너무-자주-변경됩니다",
      children: "lockfile이 너무 자주 변경됩니다"
    }), "\n", _jsxs(_components.p, {
      children: ["Docker는 앱을 배포하는 방법에 대해 매우 똑똑합니다. Turborepo와 마찬가지로 ", _jsx(_components.a, {
        href: "https://bitjudo.com/blog/2014/03/13/building-efficient-dockerfiles-node-dot-js/",
        children: "가능한 한 적은 작업"
      }), "을 수행하려고 합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["우리 Dockerfile의 경우, 이미지에 있는 파일이 이전 실행과 ", _jsx(_components.em, {
        children: "다른"
      }), " 경우에만 ", _jsx(_components.code, {
        children: "npm install"
      }), "을 실행합니다. 그렇지 않으면 이전에 있던 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 디렉터리를 복원합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["즉, ", _jsx(_components.code, {
        children: "package.json"
      }), ", ", _jsx(_components.code, {
        children: "apps/api/package.json"
      }), " 또는 ", _jsx(_components.code, {
        children: "package-lock.json"
      }), "이 변경될 때마다 Docker 이미지가 ", _jsx(_components.code, {
        children: "npm install"
      }), "을 실행합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이것은 훌륭하게 들리지만, 우리는 무언가를 깨닫습니다. ", _jsx(_components.code, {
        children: "package-lock.json"
      }), "은 monorepo에 대해 ", _jsx(_components.em, {
        children: "전역"
      }), "입니다. 즉, ", _jsxs(_components.strong, {
        children: [_jsx(_components.code, {
          children: "apps/web"
        }), " 내부에 새 패키지를 설치하면 ", _jsx(_components.code, {
          children: "apps/api"
        }), "가 재배포됩니다"]
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "대규모 monorepo에서는 monorepo의 lockfile에 대한 변경 사항이 수십 또는 수백 개의 배포로 이어지기 때문에 엄청난 시간 손실이 발생할 수 있습니다."
    }), "\n", _jsx(_components.h2, {
      id: "해결-방법",
      children: "해결 방법"
    }), "\n", _jsxs(_components.p, {
      children: ["해결 방법은 Dockerfile에 대한 입력을 엄격하게 필요한 것으로만 제한하는 것입니다. Turborepo는 간단한 해결책인 ", _jsx(_components.code, {
        children: "turbo prune"
      }), "을 제공합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " prune"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " api"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --docker"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 명령을 실행하면 ", _jsx(_components.code, {
        children: "./out"
      }), " 디렉터리 내에 ", _jsx(_components.strong, {
        children: "monorepo의 축소된 버전"
      }), "이 생성됩니다. ", _jsx(_components.code, {
        children: "api"
      }), "가 의존하는 워크스페이스만 포함합니다. 또한 ", _jsx(_components.strong, {
        children: "lockfile을 축소"
      }), "하여 관련 ", _jsx(_components.code, {
        children: "node_modules"
      }), "만 다운로드됩니다."]
    }), "\n", _jsxs(_components.h3, {
      id: "--docker-플래그",
      children: [_jsx(_components.code, {
        children: "--docker"
      }), " 플래그"]
    }), "\n", _jsxs(_components.p, {
      children: ["기본적으로 ", _jsx(_components.code, {
        children: "turbo prune"
      }), "은 모든 관련 파일을 ", _jsx(_components.code, {
        children: "./out"
      }), " 내부에 넣습니다. 그러나 Docker로 캐싱을 최적화하려면 파일을 두 단계로 복사하는 것이 이상적입니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["먼저, 패키지를 설치하는 데 필요한 것만 복사하려고 합니다. ", _jsx(_components.code, {
        children: "--docker"
      }), "를 실행하면 ", _jsx(_components.code, {
        children: "./out/json"
      }), " 내부에서 찾을 수 있습니다."]
    }), "\n", _jsx(Files, {
      children: _jsxs(Folder, {
        name: "out",
        defaultOpen: true,
        children: [_jsxs(Folder, {
          name: "json",
          defaultOpen: true,
          children: [_jsx(Folder, {
            name: "apps",
            defaultOpen: true,
            children: _jsx(Folder, {
              name: "api",
              defaultOpen: true,
              children: _jsx(File, {
                name: "package.json"
              })
            })
          }), _jsx(File, {
            name: "package.json"
          })]
        }), _jsxs(Folder, {
          name: "full",
          defaultOpen: true,
          children: [_jsx(Folder, {
            name: "apps",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "api",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "server.js"
              }), _jsx(File, {
                name: "package.json"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        }), _jsx(File, {
          name: "package-lock.json"
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["그런 다음 ", _jsx(_components.code, {
        children: "./out/full"
      }), "의 파일을 복사하여 소스 파일을 추가할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이렇게 ", _jsx(_components.strong, {
        children: "종속성"
      }), "과 ", _jsx(_components.strong, {
        children: "소스 파일"
      }), "을 분리하면 ", _jsxs(_components.strong, {
        children: ["종속성이 변경될 때만 ", _jsx(_components.code, {
          children: "npm install"
        }), "을 실행"]
      }), "할 수 있으므로 훨씬 더 큰 속도 향상을 얻을 수 있습니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "--docker"
        }), " 없이는 모든 축소된 파일이 ", _jsx(_components.code, {
          children: "./out"
        }), " 내부에 배치됩니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "예제",
      children: "예제"
    }), "\n", _jsxs(_components.p, {
      children: ["상세한 ", _jsxs(_components.a, {
        href: "https://github.com/vercel/turborepo/tree/main/examples/with-docker",
        children: [_jsx(_components.code, {
          children: "with-docker"
        }), " 예제"]
      }), "는 ", _jsx(_components.code, {
        children: "prune"
      }), "을 최대한 활용하는 방법에 대해 자세히 설명합니다. 편의를 위해 Dockerfile을 복사했습니다."]
    }), "\n", _jsx(_components.p, {
      children: "monorepo의 루트에서 Dockerfile을 빌드합니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "docker"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -f"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " apps/web/Dockerfile"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ."
            })]
          })
        })
      })
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["이 Dockerfile은 ", _jsx(_components.code, {
          children: "standalone"
        }), " ", _jsx(_components.a, {
          href: "https://nextjs.org/docs/pages/api-reference/next-config-js/output",
          children: "output\nmode"
        }), "를\n사용하는 ", _jsx(_components.a, {
          href: "https://nextjs.org/",
          children: "Next.js"
        }), " 앱용으로 작성되었습니다."]
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/Dockerfile",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " node:18-alpine "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " builder"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apk update"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apk add --no-cache libc6-compat"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Set working directory"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /app"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Replace <your-major-version> with the major version installed in your repository. For example:"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# RUN yarn global add turbo@^2"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn global add turbo@^<your-major-version>"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " . ."
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Generate a partial monorepo with a pruned lockfile for a target workspace."
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Assuming \"web\" is the name entered in the project's package.json: { name: \"web\" }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " turbo prune web --docker"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Add lockfile and package.json's of isolated subworkspace"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " installer"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apk update"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " apk add --no-cache libc6-compat"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /app"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# First install the dependencies (as they change less often)"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=builder /app/out/json/ ."
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn install --frozen-lockfile"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Build the project"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=builder /app/out/full/ ."
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn turbo run build"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "FROM"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " base "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "AS"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " runner"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "WORKDIR"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " /app"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Don't run production as root"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " addgroup --system --gid 1001 nodejs"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " adduser --system --uid 1001 nextjs"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "USER"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " nextjs"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Automatically leverage output traces to reduce image size"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# https://nextjs.org/docs/advanced-features/output-file-tracing"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=installer --chown=nextjs:nodejs /app/apps/web/.next/standalone ./"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=installer --chown=nextjs:nodejs /app/apps/web/.next/static ./apps/web/.next/static"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "COPY"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " --from=installer --chown=nextjs:nodejs /app/apps/web/public ./apps/web/public"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "CMD"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " node apps/web/server.js"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "remote-caching",
      children: "Remote Caching"
    }), "\n", _jsxs(_components.p, {
      children: ["Docker 빌드 중에 원격 캐시를 활용하려면 빌드 컨테이너가 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Cache"
      }), "에 액세스할 수 있는 자격 증명을 가지고 있어야 합니다."]
    }), "\n", _jsx(_components.p, {
      children: "Docker 이미지에서 시크릿을 처리하는 방법은 여러 가지가 있습니다. 여기서는 최종 이미지에 대해 숨겨질 빌드 인수로 시크릿을 사용하는 다단계 빌드를 사용하는 간단한 전략을 사용합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["위와 유사한 Dockerfile을 사용한다고 가정하고, ", _jsx(_components.code, {
        children: "turbo build"
      }), " 바로 전에 빌드 인수에서 일부 환경 변수를 가져옵니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/api/Dockerfile",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "ARG"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " TURBO_TEAM"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "ENV"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " TURBO_TEAM=$TURBO_TEAM"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "ARG"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " TURBO_TOKEN"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "ENV"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " TURBO_TOKEN=$TURBO_TOKEN"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "RUN"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " yarn turbo run build"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "는 이제 Remote Cache에 도달할 수 있습니다. 캐시되지 않은 Docker 빌드 이미지에 대한 Turborepo 캐시 적중을 보려면 프로젝트 루트에서 다음과 같은 명령을 실행하세요:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "docker"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -f"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " apps/web/Dockerfile"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --build-arg"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " TURBO_TEAM=“your-team-name”"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --build-arg"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " TURBO_TOKEN=“your-token“"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --no-cache"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
